<template lang="pug">
div
  .relative.d-flex(
    :class=`{
      'flex-wrap gap-8': $vuetify.breakpoint.xs,
      'gap-16': $vuetify.breakpoint.smAndUp,
    }`
  )
    .subtitle-1.pointer.py-1.weight-500(
      v-for="(item, idx) in items"
      :key="idx"
      :ref="itemValue(item.value, idx)"
      :class=`{
        'redesignBlack--text': selectedItem === itemValue(item.value, idx),
        'redesignSecondary--text': selectedItem !== itemValue(item.value, idx),
      }`
      @click="clickHandler(itemValue(item.value, idx))"
    ) {{ item.text }}
  .app-tabs-group__underline__line.relative.full-width(
    v-if="$vuetify.breakpoint.smAndUp"
  )
    .app-tabs-group__underline__thumb.redesignBlack(
      :style="thumbStyles"
    )
</template>

<script>
export default {
  name: 'AppTabsGroup',

  props: {
    value: {
      type: [Number, String, Object],
      default: 0,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      selectedItemRects: null,
    };
  },

  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },

    itemValue() {
      return (value, idx) => value || idx;
    },

    thumbStyles() {
      return {
        width: `${this.selectedItemRects?.width || 0}px`,
        marginLeft: `${this.selectedItemRects?.left || 0}px`,
      };
    },
  },

  watch: {
    selectedItem: {
      handler(item) {
        const itemIndex = this.items.findIndex((el) => el.value === item);
        const idx = Math.max(itemIndex, 0);
        const refSet = this.$refs[this.itemValue(item, idx)];
        const [ref] = refSet;
        const { offsetLeft, offsetWidth } = ref;
        this.selectedItemRects = {
          width: offsetWidth || this.calcWidthByContent(this.items[idx]?.text || ''),
          left: offsetLeft,
        };
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },

  methods: {
    init() {
      this.$nextTick(() => {
        const firstSet = this.$refs[this.itemValue(this.selectedItem, 0)];
        if (firstSet) {
          const [first] = firstSet;
          const { offsetLeft, offsetWidth } = first;
          this.selectedItemRects = {
            width: offsetWidth || this.calcWidthByContent(this.items[0]?.text || ''),
            left: offsetLeft,
          };
        }
      });
    },
    calcWidthByContent(text) {
      const oneLetterWidthPx = 9.5;
      return text.length * oneLetterWidthPx;
    },
    clickHandler(value) {
      this.selectedItem = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-tabs-group {
  &__underline {
    &__line {
      transition: all .2s !important;
      height: 2px;
    }

    &__thumb {
      height: 2px;
      transition: all .2s !important;
    }
  }
}
</style>
